module.exports = __webpack_public_path__ + "img/calendar-checkca.58990659.png";